import request from '../utils/request'
import qs from 'qs'
import {encrypt} from "../utils/rsautil" //RSA加密类
import {strToHex} from "../utils/tools"
/**
 * 根据户号获取账户信息
 * @param accessLink
 * @returns {*}
 */
export function accountInfo(accountNo){
    return request({
        url: 'user/accountInfo.do',
        method: 'post',
        data: qs.stringify({accountNo: accountNo})
    })
}
export function transferAccountNoCheck(accountNo){
    return request({
        url: 'business/transferAccountNoCheck.do',
        method: 'post',
        data: qs.stringify({no: strToHex(accountNo)})
    })
}

/**
 * 获取绑定列表
 * @returns {*}
 */
export function bindList(){
    return request({
        url: 'user/bindList.do',
        method: 'post'
    })
}

/**
 * 取消绑定户号
 * @param id
 * @param remark
 * @returns {*}
 */
export function unBindAccount(id,remark){
    return request({
        url: 'user/unBindAccount.do',
        method: 'post',
        data: qs.stringify({data:encrypt(JSON.stringify({id: id,remark:remark}))})
    })
}

/**
 * 绑定户号
 * @param refereeCode
 * @param accountNo
 * @param accountName
 */
export function addBindAccount(refereeCode,accountNo,accountName,picCode){
    return request({
        url: 'user/addNewAcount.do',
        method: 'post',
        data: qs.stringify({data:encrypt(JSON.stringify({refereeCode: refereeCode,accountNo:accountNo,accountName:accountName,picCode:picCode}))})
    })
}